import { AnomalyCategory, AnomalyType } from "@enums/transport.enum";

export class TransportPhaseData {
    id!: number;
    general_info!: GeneralInfo;
    mileage_and_fuel!: MileageAndFuel;
    signatures!: Signatures;
    photos!: Photos;
    protocols!: Protocol[];
    anomalies?: Anomaly[];
    documents!: Document[];
    additional_services!: AdditionalService[];

    /**
     * Mapea un DTO de inicio o fin a una instancia unificada de TransportPhaseData
     */
    static fromDto(data: any): TransportPhaseData {
        const instance = new TransportPhaseData();
        if (!data) return instance;

        instance.id = data.id;
        instance.general_info = GeneralInfo.fromDto(data.general_info);
        instance.mileage_and_fuel = MileageAndFuel.fromDto(data.mileage_and_fuel);

        instance.signatures = data.signatures || new Signatures();
        instance.photos = data.photos || new Photos();
        instance.protocols = data.protocols || [];
        instance.anomalies = data.anomalies || [];
        instance.documents = data.documents || [];
        instance.additional_services = data.additional_services || [];

        return instance;
    }
}

export class AdditionalService {
    id!: number;
    name!: string;
    price!: string;
    images!: PhotoItem[];
    latitude?: number | null;
    longitude?: number | null;
}

export class Anomaly {
    id!: number;
    anomaly_type!: AnomalyType;
    category!: AnomalyCategory;
    description!: string;
    phase!: string;
    leg!: number;
    created_date!: Date;
    modified_date!: Date;
    photos!: PhotoItem[];
}

export class Document {
    id!: number;
    title!: string;
    comment!: string;
    phase!: string;
    file_template?: string | null;
    file_sent!: string;
    document_template_id!: number;
    created_date!: Date;
    modified_date!: Date;
}

export class Geolocation {
    title?: string | null;
    address?: string | null;
    city?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    distance?: number | null;
}

export class GeneralInfo {
    origin!: Destination;
    destination!: Destination;
    geolocation_preparation?: Geolocation | null;
    geolocation_send?: Geolocation | null;
    driver!: Driver;
    date_real?: Date;
    date_expected?: Date;

    static fromDto(data: any): GeneralInfo {
        const instance = new GeneralInfo();
        if (!data) return instance;

        instance.origin = data.origin;
        instance.destination = data.destination;
        instance.geolocation_preparation = data.geolocation_preparation ?? new Geolocation();
        instance.geolocation_send = data.geolocation_send ?? new Geolocation();
        instance.driver = data.driver;
        instance.date_real = data.date_start_real ?? data.date_end_real;
        instance.date_expected = data.date_start_expected ?? data.date_end_expected;

        return instance;
    }
}

export class Destination {
    title!: string;
    address!: string;
    city!: string;
    latitude!: number;
    longitude!: number;
}

export class Driver {
    name!: string;
}

export class MileageAndFuel {
    mileage?: number;
    fuel?: number;

    static fromDto(data: any): MileageAndFuel {
        const instance = new MileageAndFuel();
        if (!data) return instance;

        instance.mileage = data.car_start_mileage ?? data.car_end_mileage;
        instance.fuel = data.car_start_fuel ?? data.car_end_fuel;

        return instance;
    }
}

export class Photos {
    exterior: PhotoItem[] = [];
    interior: PhotoItem[] = [];
    keys: PhotoItem[] = [];
    charging: PhotoItem[] = [];
    documents: PhotoItem[] = [];
    optional: PhotoItem[] = [];
}

export class PhotoItem {
    id!: number;
    photo_type!: string;
    photo!: string;
    optional!: boolean;
}

export class Protocol {
    protocol_id!: number;
    title!: string;
    type!: string;
    options!: Option[];
    image?: string | null;
}

export class Option {
    option_id!: number;
    title!: string;
    selected!: boolean;
}

export class Signatures {
    driver_selfie?: string;
    driver_signature!: string;
    contact_signature!: string;
}
